import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./Pages/Home";
import { PyFirstPage } from "./Python/PyFirstPage";
import { PyFirstStep } from "./Python/PyFirstStep";
import { PyFirstProgram } from "./Python/PyFirstProgram";
import { PyVariable } from "./Python/PyVariable";
import { PyDataType } from "./Python/PyDataType";
import { PyOperators } from "./Python/PyOperators";
import { PyInput } from "./Python/PyInput";
import { PyIfElse } from "./Python/PyIfElse";
import { NodeFirstPage } from "./Njs/NFirstPage";
import { NjsFirstStep } from "./Njs/NjsFirstStep";
import { NModule } from "./Njs/NModule";
import { NHttp } from "./Njs/NHttp";
import { PyWhileloop } from "./Python/PyWhileloop";
import { PyForloop } from "./Python/PyForloop";
import { PyBreak } from "./Python/PyBreak";
import { PyList } from "./Python/PyList";
import { PyTuple } from "./Python/PyTuple";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route exact path="/Pythontrainning" element={<PyFirstPage />}></Route>
        <Route exact path="/FirstStep" element={<PyFirstStep />}></Route>
        <Route exact path="/FirstProgram" element={<PyFirstProgram />}></Route>
        <Route exact path="/Variable" element={<PyVariable />}></Route>
        <Route exact path="/DataType" element={<PyDataType />}></Route>
        <Route exact path="/Operators" element={<PyOperators />}></Route>
        <Route exact path="/Input" element={<PyInput />}></Route>
        <Route exact path="/DecisionMaking" element={<PyIfElse />}></Route>
        <Route exact path="/WhileLoop" element={<PyWhileloop />}></Route>
        <Route exact path="/ForLoop" element={<PyForloop />}></Route>
        <Route exact path="/Break" element={<PyBreak />}></Route>
        <Route exact path="/List" element={<PyList />}></Route>
        <Route exact path="/Tuple" element={<PyTuple />}></Route>

        {/*                   Nodejs Start here              */}
        <Route exact path="/Nodetrainning" element={<NodeFirstPage />}></Route>
        <Route exact path="/NodeFirstStep" element={<NjsFirstStep />}></Route>
        <Route exact path="/NodeModules" element={<NModule />}></Route>
        <Route exact path="/NodeHttpModules" element={<NHttp />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
